export const dateTimeFormat = 'DD.MM.YYYY HH:mm:ss:SSS Z';